import { render, staticRenderFns } from "./GoalsAbtesting.vue?vue&type=template&id=b2df6cba&scoped=true&"
import script from "./GoalsAbtesting.vue?vue&type=script&lang=js&"
export * from "./GoalsAbtesting.vue?vue&type=script&lang=js&"
import style0 from "./GoalsAbtesting.vue?vue&type=style&index=0&id=b2df6cba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2df6cba",
  null
  
)

export default component.exports